import {PageContent} from './../../shared/classes/page-content.model';
import {Component, OnInit, AfterViewInit, ViewChild, ElementRef, ViewEncapsulation} from '@angular/core';
import {RightSideService} from '../../shared/right-side.service';
import {FormDataService} from '../../shared/form-data.service';
import {detectmob} from '../../../../app-storage';
import hbusApiClient from '../../../../analytics/hbusApiClient';

@Component({
  selector: 'app-last-tab',
  templateUrl: './last-tab.component.html',
  styleUrls: ['./last-tab.component.css'],
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'text-center mx-auto'
  }
})
export class LastTabComponent implements OnInit, AfterViewInit {
  @ViewChild('succHeader') succHeader: ElementRef;
  tabSelected = 5;
  courierNumber: string;
  categoryName: string;
  pageContent: PageContent;
  cashbackSelected: boolean;
  brandName: string;
  modelName: string;
  productPrice: number;
  courierData: object;

  constructor(
    private tabsService: RightSideService,
    private formDataService: FormDataService,
  ) {
    this.tabsService.isResultViewed = true;
    this.pageContent = this.tabsService.getPageContent();
    this.cashbackSelected = this.tabsService.getCashbackSelected();
    this.brandName = this.tabsService.getBrandName();
    this.modelName = this.tabsService.getModelName();
    this.courierData = this.tabsService.getCourier();
    this.productPrice = this.tabsService.getPrice();
    this.tabsService.pageContentChange.subscribe(() => {
      this.pageContent = this.tabsService.getPageContent();
    });
    this.categoryName = this.tabsService.getCategoryName();
    this.sendDavinciEvent();
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.scrollTop();
  }

  scrollTop() {
    const isMobile = detectmob();
    if (isMobile) {
      if (!navigator.userAgent.match(/safari/i) || localStorage == null) {
        setTimeout(() => {
          parent.postMessage({
            scrollY: (this.succHeader['sucjumb'].nativeElement.getBoundingClientRect().top + this.tabsService.getTopHeight())
          }, '*');
        });
      } else {
        setTimeout(() => {
          parent.postMessage({
            scrollY: (this.succHeader['sucjumb'].nativeElement.getBoundingClientRect().top + this.tabsService.getTopHeight())
          }, '*');
        });
      }
    } else {
      setTimeout(() => {
        parent.postMessage({
          scrollY: (this.succHeader['sucjumb'].nativeElement.getBoundingClientRect().top + this.tabsService.getTopHeight())
        }, '*');
      });
    }
  }

  sendDavinciEvent() {
    const isCourierOfficeDelivery = this.formDataService.fourthTab.deliveryType === 'courierOfficeDelivery';

    try {
      hbusApiClient.sendEventRequest('ApplicationCompleted', {
        page_type: 'static',
        page_value: 'eskiyi-getir-yeniyi-gotur',
        stepNo: 5,
        stepName: 'BasvuruTamamlandı',
        paymentOptions: this.cashbackSelected ? 'cash' : 'coupon',
        brand: this.brandName || '',
        model: this.modelName || '',
        deliverytype: isCourierOfficeDelivery ? 'isNotHomeDelivery' : 'homeDelivery',
        claimdate: isCourierOfficeDelivery ? '' : this.formDataService.fourthTab.homeDeliveryAvailableCourierSelectedDate,
        proposedAmount: this.productPrice ?
          // tslint:disable-next-line:radix
          `${parseInt(this.productPrice.toString()).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
          : '',
        buyBackCategory: this.categoryName || '',
        cargoCodeInfo: this.courierData && this.courierData['courierNumber'] || '',
        cargoBrandInfo: this.courierData && this.courierData['courier'] && this.courierData['courier'].name || '',
        clickButtonInfo: '',
      });
    } catch (e) {
      console.error('error send event', e.message);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/buyback-form/main-section/tabs/last-tab/last-tab.component.ts